import { ChangeDetectorRef, Component, EventEmitter, Input, OnInit, Output } from "@angular/core";
import { AbstractControl, Validators } from "@angular/forms";
import { InvoiceService } from "../../invoice.service";
import moment from "moment/moment";

@Component({
  selector: "app-invoice-row",
  templateUrl: "./invoice-row.component.html",
  styleUrls: ["./invoice-row.component.scss"]
})
export class InvoiceRowComponent implements OnInit {
  @Input() public isBlank: boolean = false;
  @Input() public showErrors: boolean = false;
  @Input() public rowForm: AbstractControl;
  @Input() public parent_orders: any;
  @Input() public users = [];
  @Input() public products = [];
  @Input() public lists: any;
  @Input() public index: number = 0;
  @Input() public rowTitle: string = "";
  @Input() public classes: any = {};
  @Input() public checked: boolean = false; //
  @Input() public showCheckbox: boolean = false; // &&

  @Output() public handlerGetAnalytics = new EventEmitter();
  @Output() public calculateTotalAmount = new EventEmitter();
  @Output() public removeRowGrouped = new EventEmitter();
  @Output() public removeRow = new EventEmitter();
  @Output() public toggleSelectRow = new EventEmitter();
  @Output() public handlerChangeRowType = new EventEmitter();

  payment_measure_units = [];
  invoice_services = [];
  rows_types = [];
  searching_analytics_id: boolean = false;
  months = moment.months();
  years = Array.from({ length: moment().year() - 2023 }, (_, i) => i + 2024);

  constructor(
    public _invoiceService: InvoiceService,
    private cdr: ChangeDetectorRef
  ) {
  }

  ngOnInit(): void {
    this.payment_measure_units = this.lists.payment_measure_units;
    this.rows_types = this.lists.rows_types;
    this.invoice_services = this.lists.invoice_services;
  }

  getAnalyticsId() {
    this.searching_analytics_id = true;

    this._invoiceService.getAnalyticsId(this.rowForm, this.months[this.rowForm.value.month - 1])
      .subscribe((data) => {
        if (data) {
          this.handlerGetAnalytics.emit(data);
        }
        this.searching_analytics_id = false;
        setTimeout(() => this.cdr.detectChanges(), 100);
      });
  }

  rowFieldHasError(field: string) {
    const f = this.rowForm.get(field);
    if (!f) return false;
    if (this.showErrors) {
      return f.invalid;
    } else {
      return f.invalid && f.touched;
    }
  }

  calculateRowAmount(rowForm: AbstractControl) {
    rowForm.patchValue({ total_amount: Number((rowForm.value.price * rowForm.value.quantity).toFixed(2)) });
    this.calculateTotalAmount.emit();
  }

  toggleOpenInvoiceDetail(el: HTMLElement) {
    if (el.classList.contains("active")) {
      el.classList.remove("active");
      return;
    }
    this._invoiceService.openLastRow(el);
  }

  changeRowType() {
    if (this.isBlank) return false;

    const row_type = this.rowForm.value.row_type;
    const row_type_obj = this.lists.value.rows_types.find((row: any) => row.id === row_type);
    if (!row_type_obj) return false;
    const old_value: boolean = this.rowForm.value.with_product;

    if (old_value && this.rowForm.value.with_product == (row_type_obj.other.use === "product")) {
      this.rowForm.patchValue({ with_product: old_value });
      return;
    }

    const with_product = row_type_obj.other.use === "product";

    if (this.rowForm.value.with_product !== with_product) {
      this.rowForm.patchValue({ analytics_id: null, with_product });
    }

    if (with_product) {
      this.rowForm.patchValue({ user_hash: null });
    } else {
      this.rowForm.patchValue({ product_id: null });
    }

    if (row_type_obj.other.use === "product") {
      this.rowForm.get("product_id").setValidators([Validators.required]);
    } else {
      this.rowForm.get("product_id").setValidators(null);
    }
    this.rowForm.get("product_id").updateValueAndValidity();

    this.handlerChangeRowType.emit();
  }

  changeServiceTrack() {
    const service_id = this.rowForm.value.service_track;
    const service = this.invoice_services.find((it: any) => it.id === service_id);
    this.rowForm.patchValue({ vat_code: service.other.sales_vat });
    this.cdr.detectChanges()
  }
}
